import React, { useEffect, useState } from "react";
import { restrictAlphabets } from "../../../../utils/Utils";
import IsRequiredModule from "./IsRequiredModule";
import useInput from "../../../hooks/useIndicatorInput";
import { VWAP_MODE, VWAP_TIMEFRAME_OPTIONS } from "../../../../utils/IndicatorUtils";

const getModeValue = (indicator) => {
  if (indicator.value2 !== undefined && indicator.value2 !== null && indicator.value2 !== "") {
    return String(indicator.value2);
  }

  if (indicator.value4 !== undefined && indicator.value4 !== null && indicator.value4 !== "") {
    return String(indicator.value4);
  }

  return String(VWAP_MODE.current);
};

const getTimeframeValue = (value) => (value ? String(value) : "15");

const VwapEntrySetting = (props) => {
  const { indicator, updateIndicator, isLong, t } = props;
  const [mode, setMode] = useState(getModeValue(indicator));
  const [boTimeframe, setBoTimeframe] = useState(getTimeframeValue(indicator.value3));
  const [boPeriods, bindBoPeriods, setBoPeriods] = useInput(indicator.period_num, 0);
  const [eoTimeframe, setEoTimeframe] = useState(getTimeframeValue(indicator.value5));
  const [eoPeriods, bindEoPeriods, setEoPeriods] = useInput(indicator.value6, 0);

  useEffect(() => {
    updateIndicator({
      ...indicator,
      value2: Number(mode),
      value3: Number(boTimeframe),
      period_num: Number(mode) === VWAP_MODE.average ? boPeriods : 0,
      value4: Number(mode),
      value5: Number(eoTimeframe),
      value6: Number(mode) === VWAP_MODE.average ? eoPeriods : 0,
    });
  }, [mode, boTimeframe, boPeriods, eoTimeframe, eoPeriods]);

  useEffect(() => {
    setMode(getModeValue(indicator));
    setBoTimeframe(getTimeframeValue(indicator.value3));
    setBoPeriods(indicator.period_num);
    setEoTimeframe(getTimeframeValue(indicator.value5));
    setEoPeriods(indicator.value6);
  }, [indicator]);

  const side = isLong ? t("buy") : t("sell");
  const showAverage = Number(mode) === VWAP_MODE.average;

  return (
    <div>
      <div className="d-flex justify-content-between indicator-setting-form above-buy-price above-buy-price2">
        <div>
          <label className="indicator-setting-label">
            {isLong ? t("long-strategy") : t("short-strategy")}:
          </label>
        </div>
        <div>
          <select
            className="form-control select-normal darker"
            onChange={(e) => {
              setMode(e.target.value);
            }}
            value={mode}
          >
            <option value={VWAP_MODE.current}>{t("vwap-current")}</option>
            <option value={VWAP_MODE.average}>{t("vwap-average")}</option>
          </select>
        </div>
      </div>

      {showAverage ? (
        <>
          <div className="sub-heading-indicator-setting">
            <label className="">
              {side} <span className="green-text">{t("vwap-base-order")}</span>{" "}
              {t("vwap-on-this-condition")}
            </label>
          </div>
          <div className="d-flex justify-content-between indicator-setting-form align-items-center above-buy-price above-buy-price2">
            <div>
              <label className="indicator-setting-label">{t("vwap-time-frame")}</label>
            </div>
            <div className="indicator-setting-form-input">
              <select
                className="form-control select-normal darker"
                onChange={(e) => {
                  setBoTimeframe(e.target.value);
                }}
                value={boTimeframe}
              >
                {VWAP_TIMEFRAME_OPTIONS.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="d-flex justify-content-between indicator-setting-form align-items-center above-buy-price above-buy-price2">
            <div>
              <label className="indicator-setting-label">{t("vwap-price-below-last")}</label>
            </div>
            <div className="d-flex align-items-center indicator-setting-form-input">
              <input
                type="number"
                {...bindBoPeriods}
                className="input-bg-color form-control indicator-setting-input"
                onKeyPress={(e) => {
                  restrictAlphabets(e);
                }}
              />
              <label className="indicator-setting-label ml-10">{t("periods")}</label>
            </div>
          </div>

          <div className="sub-heading-indicator-setting">
            <label className="indicator-setting-label">
              {side} <span className="green-text">{t("vwap-extra-order")}</span>{" "}
              {t("vwap-on-this-condition")}
            </label>
          </div>
          <div className="d-flex justify-content-between indicator-setting-form align-items-center above-buy-price above-buy-price2">
            <div>
              <label className="indicator-setting-label">{t("vwap-time-frame")}</label>
            </div>
            <div className="indicator-setting-form-input">
              <select
                className="form-control select-normal darker"
                onChange={(e) => {
                  setEoTimeframe(e.target.value);
                }}
                value={eoTimeframe}
              >
                {VWAP_TIMEFRAME_OPTIONS.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="d-flex justify-content-between indicator-setting-form align-items-center above-buy-price above-buy-price2">
            <div>
              <label className="indicator-setting-label">{t("vwap-price-below-last")}</label>
            </div>
            <div className="d-flex align-items-center indicator-setting-form-input">
              <input
                type="number"
                {...bindEoPeriods}
                className="input-bg-color form-control indicator-setting-input"
                onKeyPress={(e) => {
                  restrictAlphabets(e);
                }}
              />
              <label className="indicator-setting-label ml-10">{t("periods")}</label>
            </div>
          </div>
        </>
      ) : (
        <div className="d-flex justify-content-between indicator-setting-form align-items-center above-buy-price above-buy-price2">
          <div>
            <label className="indicator-setting-label">{t("vwap-time-frame")}</label>
          </div>
          <div className="indicator-setting-form-input">
            <select
              className="form-control select-normal darker"
              onChange={(e) => {
                setBoTimeframe(e.target.value);
              }}
              value={boTimeframe}
            >
              {VWAP_TIMEFRAME_OPTIONS.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      )}

      <IsRequiredModule indicator={indicator} updateIndicator={updateIndicator} t={t}></IsRequiredModule>
    </div>
  );
};

export default VwapEntrySetting;
